<template>
  <div class="user-tag" v-if="tag && tag.length">
    <div class="tag-title">用户标签</div>
    <div class="tag-container" :class="{ 'tag-container-limit': !open }">
      <div class="tag-list">
        <div class="tag-item" v-for="(item, index) in tag" :key="index">{{
          item.tag_name
        }}</div>
      </div>
    </div>
    <div class="toggle-content">
      <div class="toggle-wrapper" @click="bindToggle">
        <span>{{ open ? '收起' : '展开更多' }}</span
        ><span class="iconfont icon-black" :class="{ rotate: open }"></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    tag: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      open: false
    }
  },
  created() {},
  methods: {
    bindToggle() {
      this.open = !this.open
    }
  }
}
</script>
<style lang="scss" scoped>
.user-tag {
  border-top: 1px dashed rgba(0, 0, 0, 0.3);
  padding: 10px 0px 4px;
  .tag-title {
    font-weight: bold;
    margin-bottom: 6px;
  }
  .tag-container {
    overflow: hidden;
    transition: all 1s ease;
    .tag-list {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      .tag-item {
        max-width: 100%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        background-color: rgb(236, 238, 254);
        border: 1px solid rgb(183, 192, 247);
        padding: 0px 4px;
        font-size: 14px;
        line-height: 20px;
        color: #7651fd;
        border-radius: 4px;
        margin-bottom: 10px;
        margin-right: 6px;
      }
    }
  }
  .tag-container-limit {
    height: 22px;
  }
  .toggle-content {
    margin-top: 6px;
    color: rgba(0, 0, 0, 0.7);
    display: flex;
    align-items: center;
    justify-content: flex-end;
    .toggle-wrapper {
      display: inline-flex;
      align-items: center;
    }
    .iconfont {
      margin-left: 4px;
      width: 14px;
      height: 14px;
      box-sizing: border-box;
      border-radius: 50%;
      border: 1px solid rgba(0, 0, 0, 0.7);
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .rotate {
      transform: rotate(180deg);
    }
  }
}
</style>
